/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AddFeatureFlagActorInput,
  FeatureFlag,
  FeatureFlagActorCollection,
  FeatureFlagCollection,
  FeatureFlagGroupCollection,
  FeatureFlagGroupInput,
  FeatureFlagPercentageInput,
  RemoveFeatureFlagActorInput,
  SchemaValidationErrorResponse,
  SearchFeatureFlagActorCandidatesParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of feature flags
 */
export const listFeatureFlags = (

 signal?: AbortSignal
) => {


      return axiosClient<FeatureFlagCollection>(
      {url: `/feature_flags`, method: 'GET', signal
    },
      );
    }




export const getListFeatureFlagsQueryKey = () => {
    return [
    'feature_flags'
    ] as const;
    }


export const getListFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof listFeatureFlags>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlags>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeatureFlagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeatureFlags>>> = ({ signal }) => listFeatureFlags(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlags>>, TError, TData>
}

export type ListFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeatureFlags>>>
export type ListFeatureFlagsQueryError = ErrorType<void>


/**
 * @summary List of feature flags
 */

export function useListFeatureFlags<TData = Awaited<ReturnType<typeof listFeatureFlags>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlags>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search users to add as feature-flag actors
 */
export const searchFeatureFlagActorCandidates = (
    params?: MaybeRefOrGetter<SearchFeatureFlagActorCandidatesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FeatureFlagActorCollection>(
      {url: `/feature_flags/actor_candidates`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchFeatureFlagActorCandidatesQueryKey = (params?: MaybeRefOrGetter<SearchFeatureFlagActorCandidatesParams>,) => {
    return [
    'feature_flags','actor_candidates', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchFeatureFlagActorCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof searchFeatureFlagActorCandidates>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<SearchFeatureFlagActorCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchFeatureFlagActorCandidates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchFeatureFlagActorCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchFeatureFlagActorCandidates>>> = ({ signal }) => searchFeatureFlagActorCandidates(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchFeatureFlagActorCandidates>>, TError, TData>
}

export type SearchFeatureFlagActorCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof searchFeatureFlagActorCandidates>>>
export type SearchFeatureFlagActorCandidatesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Search users to add as feature-flag actors
 */

export function useSearchFeatureFlagActorCandidates<TData = Awaited<ReturnType<typeof searchFeatureFlagActorCandidates>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<SearchFeatureFlagActorCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchFeatureFlagActorCandidates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchFeatureFlagActorCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List the registered feature-flag groups
 */
export const listFeatureFlagGroups = (

 signal?: AbortSignal
) => {


      return axiosClient<FeatureFlagGroupCollection>(
      {url: `/feature_flags/groups`, method: 'GET', signal
    },
      );
    }




export const getListFeatureFlagGroupsQueryKey = () => {
    return [
    'feature_flags','groups'
    ] as const;
    }


export const getListFeatureFlagGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listFeatureFlagGroups>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeatureFlagGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeatureFlagGroups>>> = ({ signal }) => listFeatureFlagGroups(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagGroups>>, TError, TData>
}

export type ListFeatureFlagGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeatureFlagGroups>>>
export type ListFeatureFlagGroupsQueryError = ErrorType<void>


/**
 * @summary List the registered feature-flag groups
 */

export function useListFeatureFlagGroups<TData = Awaited<ReturnType<typeof listFeatureFlagGroups>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlagGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFeatureFlagGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Enable a feature flag for a specific user
 */
export const addFeatureFlagActor = (
    name: MaybeRefOrGetter<string>,
    addFeatureFlagActorInput?: MaybeRefOrGetter<AddFeatureFlagActorInput>,
 signal?: AbortSignal
) => {
      name = toValue(name);
addFeatureFlagActorInput = toValue(addFeatureFlagActorInput);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/add_actor`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addFeatureFlagActorInput, signal
    },
      );
    }




export const getAddFeatureFlagActorMutationKey = () => ['addFeatureFlagActor'] as const;

export const getAddFeatureFlagActorMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeatureFlagActor>>, TError,AddFeatureFlagActorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addFeatureFlagActor>>, TError,AddFeatureFlagActorMutationVariables, TContext> => {

const mutationKey = getAddFeatureFlagActorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFeatureFlagActor>>, AddFeatureFlagActorMutationVariables> = (props) => {
          const {name,data} = props ?? {};

          return  addFeatureFlagActor(name,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFeatureFlagActorMutationResult = NonNullable<Awaited<ReturnType<typeof addFeatureFlagActor>>>
    export type AddFeatureFlagActorMutationBody = AddFeatureFlagActorInput | undefined
    export type AddFeatureFlagActorMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type AddFeatureFlagActorMutationVariables = {name: string;data?: AddFeatureFlagActorInput}

    /**
 * @summary Enable a feature flag for a specific user
 */
export const useAddFeatureFlagActor = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeatureFlagActor>>, TError,AddFeatureFlagActorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addFeatureFlagActor>>,
        TError,
        AddFeatureFlagActorMutationVariables,
        TContext
      > => {
      return useMutation(getAddFeatureFlagActorMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable a feature flag for a registered group
 */
export const addFeatureFlagGroup = (
    name: MaybeRefOrGetter<string>,
    featureFlagGroupInput?: MaybeRefOrGetter<FeatureFlagGroupInput>,
 signal?: AbortSignal
) => {
      name = toValue(name);
featureFlagGroupInput = toValue(featureFlagGroupInput);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/add_group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagGroupInput, signal
    },
      );
    }




export const getAddFeatureFlagGroupMutationKey = () => ['addFeatureFlagGroup'] as const;

export const getAddFeatureFlagGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeatureFlagGroup>>, TError,AddFeatureFlagGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addFeatureFlagGroup>>, TError,AddFeatureFlagGroupMutationVariables, TContext> => {

const mutationKey = getAddFeatureFlagGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFeatureFlagGroup>>, AddFeatureFlagGroupMutationVariables> = (props) => {
          const {name,data} = props ?? {};

          return  addFeatureFlagGroup(name,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFeatureFlagGroupMutationResult = NonNullable<Awaited<ReturnType<typeof addFeatureFlagGroup>>>
    export type AddFeatureFlagGroupMutationBody = FeatureFlagGroupInput | undefined
    export type AddFeatureFlagGroupMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type AddFeatureFlagGroupMutationVariables = {name: string;data?: FeatureFlagGroupInput}

    /**
 * @summary Enable a feature flag for a registered group
 */
export const useAddFeatureFlagGroup = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFeatureFlagGroup>>, TError,AddFeatureFlagGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addFeatureFlagGroup>>,
        TError,
        AddFeatureFlagGroupMutationVariables,
        TContext
      > => {
      return useMutation(getAddFeatureFlagGroupMutationOptions(options), queryClient);
    }
    /**
 * @summary Clear all gates for a feature flag
 */
export const clearFeatureFlagGates = (
    name: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      name = toValue(name);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/clear_gates`, method: 'PUT', signal
    },
      );
    }




export const getClearFeatureFlagGatesMutationKey = () => ['clearFeatureFlagGates'] as const;

export const getClearFeatureFlagGatesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearFeatureFlagGates>>, TError,ClearFeatureFlagGatesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clearFeatureFlagGates>>, TError,ClearFeatureFlagGatesMutationVariables, TContext> => {

const mutationKey = getClearFeatureFlagGatesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearFeatureFlagGates>>, ClearFeatureFlagGatesMutationVariables> = (props) => {
          const {name} = props ?? {};

          return  clearFeatureFlagGates(name,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearFeatureFlagGatesMutationResult = NonNullable<Awaited<ReturnType<typeof clearFeatureFlagGates>>>

    export type ClearFeatureFlagGatesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ClearFeatureFlagGatesMutationVariables = {name: string}

    /**
 * @summary Clear all gates for a feature flag
 */
export const useClearFeatureFlagGates = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearFeatureFlagGates>>, TError,ClearFeatureFlagGatesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof clearFeatureFlagGates>>,
        TError,
        ClearFeatureFlagGatesMutationVariables,
        TContext
      > => {
      return useMutation(getClearFeatureFlagGatesMutationOptions(options), queryClient);
    }
    /**
 * @summary Deactivate a feature flag
 */
export const disableFeatureFlag = (
    name: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      name = toValue(name);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/disable`, method: 'PUT', signal
    },
      );
    }




export const getDisableFeatureFlagMutationKey = () => ['disableFeatureFlag'] as const;

export const getDisableFeatureFlagMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableFeatureFlag>>, TError,DisableFeatureFlagMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableFeatureFlag>>, TError,DisableFeatureFlagMutationVariables, TContext> => {

const mutationKey = getDisableFeatureFlagMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableFeatureFlag>>, DisableFeatureFlagMutationVariables> = (props) => {
          const {name} = props ?? {};

          return  disableFeatureFlag(name,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof disableFeatureFlag>>>

    export type DisableFeatureFlagMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DisableFeatureFlagMutationVariables = {name: string}

    /**
 * @summary Deactivate a feature flag
 */
export const useDisableFeatureFlag = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableFeatureFlag>>, TError,DisableFeatureFlagMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableFeatureFlag>>,
        TError,
        DisableFeatureFlagMutationVariables,
        TContext
      > => {
      return useMutation(getDisableFeatureFlagMutationOptions(options), queryClient);
    }
    /**
 * @summary Fully activate a feature flag
 */
export const enableFeatureFlag = (
    name: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      name = toValue(name);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/enable`, method: 'PUT', signal
    },
      );
    }




export const getEnableFeatureFlagMutationKey = () => ['enableFeatureFlag'] as const;

export const getEnableFeatureFlagMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableFeatureFlag>>, TError,EnableFeatureFlagMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableFeatureFlag>>, TError,EnableFeatureFlagMutationVariables, TContext> => {

const mutationKey = getEnableFeatureFlagMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableFeatureFlag>>, EnableFeatureFlagMutationVariables> = (props) => {
          const {name} = props ?? {};

          return  enableFeatureFlag(name,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof enableFeatureFlag>>>

    export type EnableFeatureFlagMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type EnableFeatureFlagMutationVariables = {name: string}

    /**
 * @summary Fully activate a feature flag
 */
export const useEnableFeatureFlag = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableFeatureFlag>>, TError,EnableFeatureFlagMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableFeatureFlag>>,
        TError,
        EnableFeatureFlagMutationVariables,
        TContext
      > => {
      return useMutation(getEnableFeatureFlagMutationOptions(options), queryClient);
    }
    /**
 * @summary Set the percentage-of-actors gate for a feature flag
 */
export const setFeatureFlagPercentageOfActors = (
    name: MaybeRefOrGetter<string>,
    featureFlagPercentageInput?: MaybeRefOrGetter<FeatureFlagPercentageInput>,
 signal?: AbortSignal
) => {
      name = toValue(name);
featureFlagPercentageInput = toValue(featureFlagPercentageInput);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/percentage_of_actors`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagPercentageInput, signal
    },
      );
    }




export const getSetFeatureFlagPercentageOfActorsMutationKey = () => ['setFeatureFlagPercentageOfActors'] as const;

export const getSetFeatureFlagPercentageOfActorsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagPercentageOfActors>>, TError,SetFeatureFlagPercentageOfActorsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagPercentageOfActors>>, TError,SetFeatureFlagPercentageOfActorsMutationVariables, TContext> => {

const mutationKey = getSetFeatureFlagPercentageOfActorsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setFeatureFlagPercentageOfActors>>, SetFeatureFlagPercentageOfActorsMutationVariables> = (props) => {
          const {name,data} = props ?? {};

          return  setFeatureFlagPercentageOfActors(name,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetFeatureFlagPercentageOfActorsMutationResult = NonNullable<Awaited<ReturnType<typeof setFeatureFlagPercentageOfActors>>>
    export type SetFeatureFlagPercentageOfActorsMutationBody = FeatureFlagPercentageInput | undefined
    export type SetFeatureFlagPercentageOfActorsMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type SetFeatureFlagPercentageOfActorsMutationVariables = {name: string;data?: FeatureFlagPercentageInput}

    /**
 * @summary Set the percentage-of-actors gate for a feature flag
 */
export const useSetFeatureFlagPercentageOfActors = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagPercentageOfActors>>, TError,SetFeatureFlagPercentageOfActorsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setFeatureFlagPercentageOfActors>>,
        TError,
        SetFeatureFlagPercentageOfActorsMutationVariables,
        TContext
      > => {
      return useMutation(getSetFeatureFlagPercentageOfActorsMutationOptions(options), queryClient);
    }
    /**
 * @summary Set the percentage-of-time gate for a feature flag
 */
export const setFeatureFlagPercentageOfTime = (
    name: MaybeRefOrGetter<string>,
    featureFlagPercentageInput?: MaybeRefOrGetter<FeatureFlagPercentageInput>,
 signal?: AbortSignal
) => {
      name = toValue(name);
featureFlagPercentageInput = toValue(featureFlagPercentageInput);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/percentage_of_time`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagPercentageInput, signal
    },
      );
    }




export const getSetFeatureFlagPercentageOfTimeMutationKey = () => ['setFeatureFlagPercentageOfTime'] as const;

export const getSetFeatureFlagPercentageOfTimeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagPercentageOfTime>>, TError,SetFeatureFlagPercentageOfTimeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagPercentageOfTime>>, TError,SetFeatureFlagPercentageOfTimeMutationVariables, TContext> => {

const mutationKey = getSetFeatureFlagPercentageOfTimeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setFeatureFlagPercentageOfTime>>, SetFeatureFlagPercentageOfTimeMutationVariables> = (props) => {
          const {name,data} = props ?? {};

          return  setFeatureFlagPercentageOfTime(name,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetFeatureFlagPercentageOfTimeMutationResult = NonNullable<Awaited<ReturnType<typeof setFeatureFlagPercentageOfTime>>>
    export type SetFeatureFlagPercentageOfTimeMutationBody = FeatureFlagPercentageInput | undefined
    export type SetFeatureFlagPercentageOfTimeMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type SetFeatureFlagPercentageOfTimeMutationVariables = {name: string;data?: FeatureFlagPercentageInput}

    /**
 * @summary Set the percentage-of-time gate for a feature flag
 */
export const useSetFeatureFlagPercentageOfTime = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagPercentageOfTime>>, TError,SetFeatureFlagPercentageOfTimeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof setFeatureFlagPercentageOfTime>>,
        TError,
        SetFeatureFlagPercentageOfTimeMutationVariables,
        TContext
      > => {
      return useMutation(getSetFeatureFlagPercentageOfTimeMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable a feature flag for a specific actor gate
 */
export const removeFeatureFlagActor = (
    name: MaybeRefOrGetter<string>,
    removeFeatureFlagActorInput?: MaybeRefOrGetter<RemoveFeatureFlagActorInput>,
 signal?: AbortSignal
) => {
      name = toValue(name);
removeFeatureFlagActorInput = toValue(removeFeatureFlagActorInput);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/remove_actor`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: removeFeatureFlagActorInput, signal
    },
      );
    }




export const getRemoveFeatureFlagActorMutationKey = () => ['removeFeatureFlagActor'] as const;

export const getRemoveFeatureFlagActorMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFeatureFlagActor>>, TError,RemoveFeatureFlagActorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeFeatureFlagActor>>, TError,RemoveFeatureFlagActorMutationVariables, TContext> => {

const mutationKey = getRemoveFeatureFlagActorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFeatureFlagActor>>, RemoveFeatureFlagActorMutationVariables> = (props) => {
          const {name,data} = props ?? {};

          return  removeFeatureFlagActor(name,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFeatureFlagActorMutationResult = NonNullable<Awaited<ReturnType<typeof removeFeatureFlagActor>>>
    export type RemoveFeatureFlagActorMutationBody = RemoveFeatureFlagActorInput | undefined
    export type RemoveFeatureFlagActorMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RemoveFeatureFlagActorMutationVariables = {name: string;data?: RemoveFeatureFlagActorInput}

    /**
 * @summary Disable a feature flag for a specific actor gate
 */
export const useRemoveFeatureFlagActor = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFeatureFlagActor>>, TError,RemoveFeatureFlagActorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeFeatureFlagActor>>,
        TError,
        RemoveFeatureFlagActorMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveFeatureFlagActorMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable a feature flag for a registered group
 */
export const removeFeatureFlagGroup = (
    name: MaybeRefOrGetter<string>,
    featureFlagGroupInput?: MaybeRefOrGetter<FeatureFlagGroupInput>,
 signal?: AbortSignal
) => {
      name = toValue(name);
featureFlagGroupInput = toValue(featureFlagGroupInput);

      return axiosClient<FeatureFlag>(
      {url: `/feature_flags/${name}/remove_group`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagGroupInput, signal
    },
      );
    }




export const getRemoveFeatureFlagGroupMutationKey = () => ['removeFeatureFlagGroup'] as const;

export const getRemoveFeatureFlagGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFeatureFlagGroup>>, TError,RemoveFeatureFlagGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeFeatureFlagGroup>>, TError,RemoveFeatureFlagGroupMutationVariables, TContext> => {

const mutationKey = getRemoveFeatureFlagGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFeatureFlagGroup>>, RemoveFeatureFlagGroupMutationVariables> = (props) => {
          const {name,data} = props ?? {};

          return  removeFeatureFlagGroup(name,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveFeatureFlagGroupMutationResult = NonNullable<Awaited<ReturnType<typeof removeFeatureFlagGroup>>>
    export type RemoveFeatureFlagGroupMutationBody = FeatureFlagGroupInput | undefined
    export type RemoveFeatureFlagGroupMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RemoveFeatureFlagGroupMutationVariables = {name: string;data?: FeatureFlagGroupInput}

    /**
 * @summary Disable a feature flag for a registered group
 */
export const useRemoveFeatureFlagGroup = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFeatureFlagGroup>>, TError,RemoveFeatureFlagGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeFeatureFlagGroup>>,
        TError,
        RemoveFeatureFlagGroupMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveFeatureFlagGroupMutationOptions(options), queryClient);
    }
